import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolBarContext = /*#__PURE__*/createContext({
  use: undefined,
  isFilled: undefined
});
export const useToolBarContext = () => {
  const toolBarContext = useContext(ToolBarContext);
  return toolBarContext;
};
export const isInFilledToolbar = toolbarContext => {
  var _toolbarContext$isFil;
  return (_toolbarContext$isFil = toolbarContext === null || toolbarContext === void 0 ? void 0 : toolbarContext.isFilled) !== null && _toolbarContext$isFil !== void 0 ? _toolbarContext$isFil : false;
};
export const useIsInFilledToolbar = () => {
  const toolbarContext = useToolBarContext();
  return isInFilledToolbar(toolbarContext);
};
export const withToolBarContext = WrappedComponent => {
  const ComponentWithToolBarContext = props => {
    const toolBarContext = useToolBarContext();
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      toolBarContext: toolBarContext
    }));
  };
  ComponentWithToolBarContext.displayName = `withToolBarContext(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return ComponentWithToolBarContext;
};